export default __webpack_public_path__ + "static/media/strawberry-french-toast.4e394af4.png";